import { TNewbuildingInfrastructureState } from 'shared/types/newbuildingInfrastructure';
import { ITypedReduxAction } from 'shared/types/redux/actionType';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

export enum ENewbuildingInfrastructureActionTypes {
  SetInfrastructure = 'newbuildingInfrastructure/set',
}

export type TSetNewbuildingInfrastructureActionPayload = TNewbuildingInfrastructureState;

export type TSetNewbuildingInfrastructureAction = ITypedReduxAction<
  ENewbuildingInfrastructureActionTypes.SetInfrastructure,
  TSetNewbuildingInfrastructureActionPayload
>;

export const setNewbuildingInfrastructureAction: (
  payload: TSetNewbuildingInfrastructureActionPayload,
) => TSetNewbuildingInfrastructureAction = actionGenerator<
  ENewbuildingInfrastructureActionTypes.SetInfrastructure,
  TSetNewbuildingInfrastructureActionPayload
>(ENewbuildingInfrastructureActionTypes.SetInfrastructure);
